import React, { useEffect, useState, useContext } from "react";
import Breadcrumb from "../components/Breadcrumb";
import axios from "axios";
import { OperaContext } from "../context/OperaContext";

function Reviews() {
  useContext(OperaContext);
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  // Memoize a map of venue IDs to names for efficient lookup

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await axios.get("/api/information/public/reviews");
        // Handle different possible response formats
        let reviewsData = response.data;
        // If response.data has an entries property, use that
        if (
          reviewsData &&
          reviewsData.entries &&
          Array.isArray(reviewsData.entries)
        ) {
          reviewsData = reviewsData.entries;
        }
        // If response.data is not an array but response.data.reviews exists
        else if (
          reviewsData &&
          reviewsData.reviews &&
          Array.isArray(reviewsData.reviews)
        ) {
          reviewsData = reviewsData.reviews;
        }
        // If response.data is not an array, default to empty array
        else if (!Array.isArray(reviewsData)) {
          reviewsData = [];
        }
        setReviews(reviewsData);
      } catch (error) {
        console.error("Error fetching reviews:", error);
        setReviews([]);
      } finally {
        setLoading(false);
      }
    };
    fetchReviews();
  }, []);

  if (loading) {
    return (
      <div className="bg-white min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-600 mx-auto"></div>
          <p className="mt-4 text-gray-700">Loading reviews...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white min-h-screen">
      {/* Hero Section */}
      <div className="relative w-full h-[250px] md:h-[400px] overflow-hidden">
        <img
          src="/images/Teatro_alla_Scala.jpg"
          alt="Reviews Hero"
          className="w-full h-full object-cover"
        />
      </div>
      {/* Breadcrumb */}
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "Testimonials", href: "/testimonials" },
        ]}
      />
      {/* Main Content */}
      <main
        className="max-w-[1280px] mx-auto py-12 px-6 md:px-12"
        aria-label="Customer reviews"
      >
        <h1 className="text-4xl md:text-3xl text-left mb-4">
          Testimonials
        </h1>
        <p className="text-black text-lg font-normal mb-8 text-left md:text-left">
          Read reviews and testimonials from our OperaToday.org travelers!
        </p>
        {reviews.length === 0 ? (
          <p className="text-black italic text-center py-12">
            No reviews available at the moment.
          </p>
        ) : (
          <div className="space-y-6">
            {reviews.map((review, index) => (
              <React.Fragment key={index}>
                <blockquote className="mb-6" role="blockquote">
                  <p className="text-black text-base leading-normal whitespace-pre-wrap">
                    {review.text || review}
                  </p>
                  <div className="text-left text-sm mt-2">
                    <p className="font-medium text-black text-left">
                      {review.name || "Anonymous"}
                    </p>
                    {review.date && (
                      <p className="font-normal text-black text-left">
                        {new Date(review.date).toLocaleDateString('en-UK', {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                        })}
                      </p>
                    )}
                  </div>
                </blockquote>
                {index < reviews.length - 1 && (
                  <hr className="border-t border-gray-200 my-6" />
                )}
              </React.Fragment>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}

export default Reviews;
